module.exports = __webpack_public_path__ + "img/logo-icon.d1412378.png";